<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="assets"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-success"
            @click="$router.push(`/ativos/novo-ativo`).catch((err) => {})"
          >
            <span class="ml-2 text-base text-white">Novo Ativo</span>
          </div>
         <!-- <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-primary"
            @click="$router.push(`/enviadas`).catch((err) => {})"
          >
            <span class="ml-2 text-base text-white">Enviadas</span>
          </div>-->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                assets.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : assets.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="idPermanentAsset">Código Ativo</vs-th>
        <vs-th sort-key="name"> Nome</vs-th>
        <vs-th sort-key="corporateName">Cliente</vs-th>
        <vs-th sort-key="owner">Proprietário</vs-th>
        <vs-th sort-key="serialNumber">Serial</vs-th>
        <vs-th>Ação</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr
            :data="assets"
            :key="indextr"
            v-for="(assets, indextr) in data"
          >
            <vs-td>
              <p class="product-name font-medium truncate">
                 <!--{{ assets.idPermanentAsset}} -->
                <vs-chip color="success"> {{ assets.idPermanentAsset}}</vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
               {{ assets.name}}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium">
                 {{ assets.corporateName}}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                  {{ assets.owner}}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                  {{ assets.serialNumber}}
              </p>
            </vs-td>
            <vs-td>
              <div align="center">
                <vs-dropdown vs-custom-content vs-trigger-click>
                  <a
                    class="flex items-center"
                    style="font-weight: 500; font-size: 1rem"
                    href="#"
                  >
                    Mais <i class="material-icons"> expand_more </i>
                  </a>
                  <vs-dropdown-menu class="w-48">
                     <vs-dropdown-item @click="edit(assets.idPermanentAsset)"
                      ><font-awesome-icon
                        :icon="['fa', 'edit']"
                        class="w-4"
                      />
                      Editar
                    </vs-dropdown-item>
                   <!--<vs-dropdown-item @click="download(order.idOrder)"
                      ><font-awesome-icon
                        :icon="['far', 'file-pdf']"
                        class="w-4"
                      />
                      Download
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      divider
                      @click.stop="deleteData(order.idOrder)"
                    >
                      <font-awesome-icon
                        :icon="['far', 'trash-alt']"
                        class="w-4"
                      />
                      Excluir
                    </vs-dropdown-item>-->
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
</div>
</template>
 
 
<script>
import axios from "axios";
import { baseApiUrl } from "@/global";

export default {
  components: {},
  data() {
    return {
      assets: [],
      itemsPerPage: 100,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      activeAlert: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.tableassets
        ? this.$refs.tableassets.queriedResults.length
        : this.assets.length;
    },
  },
  methods: {
     edit(idPermanentAsset) {
      this.$router.push(`/ativos/${idPermanentAsset}`).catch((err) => {});
    },
    getOrderStatusColor(status) {
      if (status == "on_hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    async loadPermanentAssets() {
      try {
        this.$vs.loading();
        const response = await axios.get(
          `${baseApiUrl}/permanentAsset/getPermanentAssets?finality=Revenda`
        );
        this.$vs.loading.close();
        this.assets = response.data
      } catch (error) {
        console.log(error);

        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      finally {
        this.$vs.loading.close();
      }

    },
  },
  async created() {
    this.loadPermanentAssets();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>